module.exports = __webpack_public_path__ + "static/media/brand-refresh-plus.846363d5.svg";